import React from 'react'
import CampaignPage from 'Containers/Campaigns/Page'
import { PageWrapper } from 'Components/Campaigns/Page/PageWrapper'
import LiveMapContainer from 'Components/LiveMap'
import useGraphQLFetch from '../../../../Utils/Hooks/useGraphQLFetch'
import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'
import { styles } from './styled'
import injectStyles from 'react-jss'

const getCityPlanData = async ({ campaignId, cityPlanId }) => {
  const query = `query
    (
    $campaignId:ID!
    ) {
      campaign(id:$campaignId){
        id
        cityPlans {
          nodes {
            id
            city {
              id
              name
            }
          }
        }
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    cityPlanId,
  })
}

const formatData = ({ campaign: campaignData }, cityPlanId) => {
  const citiesMap = campaignData.cityPlans.nodes.reduce((acc, plan) => {
    acc[plan.city.id] = {
      label: plan.city.name,
      value: plan.city.id,
    }
    return acc
  }, {})

  return Object.values(citiesMap)
}

const LiveMapPage = props => {
  const { classes, match } = props
  const { campaignId, cityPlanId } = match.params
  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getCityPlanData,
    defaultFetchArgs: { campaignId, cityPlanId },
    mapResponse: data => formatData(data, cityPlanId),
  })
  if (!isLoaded) return <div className={classes.wrapper}>Loading...</div>

  return (
    <CampaignPage
      active={props.nav}
      campaignId={props.match.params.campaignId}
      history={props.history}
      match={props.match}
      location={props.location}
    >
      <PageWrapper>
        <div className={classes.wrapper}>
          {data.length > 0 && (
            <LiveMapContainer
              campaignId={props.match.params.campaignId}
              cities={data}
              cityId={data[0].value}
              {...props}
            />
          )}
        </div>
      </PageWrapper>
    </CampaignPage>
  )
}

export default injectStyles(styles)(LiveMapPage)
